module.exports = __webpack_public_path__ + "static/impact-analysis-construction-47298dd6a2e9bfee4008f2e16a601dcb.png";